import React from 'react';

export default function ActionsCell({ children, className = '' }) {
  return <div className={`flex items-center gap-1 ${className}`}>{children}</div>;
}
